<template>
  <div class="sb-left-menu">
    <div id="menuIcon">
      <v-toolbar-side-icon
        :class="[drawer ? 'sb-sidebar-open' : '', 'main-hamburger-menu']"
        @click.stop="drawer = !drawer"
      >
        <span class="line-1" /><span class="line-2" /><span class="line-3" />
      </v-toolbar-side-icon>
      <v-divider />
    </div>
    <div @mouseover="openDrawer" @mouseleave="closeDrawer">
      <v-navigation-drawer
        :mini-variant.sync="closed"
        :mini-variant-width="width"
        floating
        touchless
        expand-on-hover
        app
        clipped
        permanent
        :class="`sb-nav-drawer ${
          mountedInOldLayout ? 'old-layout' : undefined
        }`"
      >
        <vuescroll ref="vs" :ops="ops">
          <v-list dense>
            <div
              v-for="(group, idx) in navBarGroups"
              :key="`nav-bar-group-${idx}`"
            >
              <v-list-tile
                v-for="(item, jdx) in group"
                :id="item.id || item.title"
                :key="`nav-bar-item-${idx}-${jdx}`"
                :class="item.id ? 'pointer' : ''"
                :href="item.useRouter ? undefined : item.link"
                :to="item.useRouter ? item.link : undefined"
                :value="highlightActiveLink(item)"
              >
                <template v-if="!item.link && item.subModules">
                  <v-list-group v-model="item.active" no-action>
                    <template v-slot:activator>
                      <v-list-tile-action :title="item.title">
                        <v-icon class="material-icons-outlined">
                          {{ item.iconText }}
                        </v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ item.title }}
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </template>

                    <v-list-tile
                      v-for="(subLink, i) in item.subModules"
                      :key="i"
                      :href="subLink.href"
                      :value="highlightActiveLink(subLink)"
                    >
                      <v-list-tile-title>
                        <v-icon
                          v-if="subLink.iconText"
                          class="material-icons-outlined vertical-middle"
                        >
                          {{ subLink.iconText }}
                        </v-icon>
                        {{ subLink.text }}
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list-group>
                </template>
                <template v-else>
                  <v-list-tile-action :title="item.title">
                    <v-icon class="material-icons-outlined">
                      {{ item.iconText }}
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ item.title }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </v-list-tile>
            </div>
          </v-list>
        </vuescroll>
      </v-navigation-drawer>
    </div>
  </div>
</template>

<script>
const easings = ['easeInQuad'];
import vuescroll from 'vuescroll';
import moduleDetails from '../pages/HomeModules.mixin.js';
import SbBaseUrl from '../plugins/SbBaseUrl.js';

export default {
  name: 'MainLayoutSidebar',
  components: {
    vuescroll,
  },
  mixins: [moduleDetails],
  props: {
    width: {
      type: Number,
      default() {
        return 60;
      },
    },
    mountedInOldLayout: {
      type: Boolean,
    },
  },
  data() {
    return {
      hovering: false,
      drawer: false,
      homeLink: {
        title: '',
        link: this.SbBaseUrl + '/Home#/',
        iconText: 'home',
        useRouter: false,
      },
      moduleLinks: [],
      // ScrollBar
      operation: {
        rail: {
          size: '0px',
        },
        bar: {
          size: '5px',
          opacity: 0.5,
          onlyShowBarOnScroll: false,
        },
      },
      ops: {
        rail: {
          opacity: '0.2',
          background: undefined,
          border: '1px solid #cecece',
          size: '5px',
        },
        bar: {
          background: '#fff',
          keepShow: false,
          size: '5px',
          minSize: 0.2,
        },
        scrollButton: {
          enable: true,
          background: '#cecece',
        },
        scrollPanel: {
          easing: 'easeInQuad',
          speed: 800,
          scrollingX: false,
        },
        vuescroll: {
          wheelScrollDuration: 0,
          wheelDirectionReverse: false,
          locking: true,
          checkShifKey: true,
        },
      },
      //width: '',
      easings,
      dataCount: 1024,
      items: [],
    };
  },
  computed: {
    open() {
      return this.drawer;
    },
    closed: {
      get() {
        return !this.open;
      },
      // fix error from trying to set a computed value, but don't do anything
      set() {},
    },
    navBarGroups() {
      return [[this.homeLink], this.moduleLinks];
    },
    currentLink() {
      let path = window.location.pathname
        .toLowerCase()
        .replace('/home/index', '')
        .replace(/\/$/, '');
      return (window.location.origin + path).toLowerCase();
    },
  },
  watch: {
    open: function (sidebarOpen) {
      if (this.mountedInOldLayout) {
        if (sidebarOpen) {
          document
            .getElementById('OldHamburgerMenu')
            .classList.add('menu-open');
        } else {
          document
            .getElementById('OldHamburgerMenu')
            .classList.remove('menu-open');
        }
      }
      if (!sidebarOpen) this.closeSubMenus();
    },
  },
  async mounted() {
    await fetch(`${SbBaseUrl.baseUrl}/License/Get`)
      .then((response) => response.json())
      // eslint-disable-next-line complexity
      .then((data) => {
        if (data && data.length > 0) {
          if (data[0].lcsType_IntelligentDiscovery === true) {
            this.homeLink.title = 'Intelligent Discovery';
          } else {
            this.homeLink.title = 'Hygiene Hub';
          }
        }
      });
    this.moduleLinks = this.getUserModules();
    this.addListenerForNavDrawerClicks();
  },
  methods: {
    openDrawer() {
      if (!this.drawer) {
        this.hovering = true;
        setTimeout(() => (this.drawer = this.hovering), 600);
      }
    },
    closeDrawer() {
      if (this.hovering) {
        this.hovering = false;
        this.drawer = false;
      }
    },
    closeSubMenus() {
      this.moduleLinks = this.moduleLinks.map((l) => {
        l.active = false;
        return l;
      });
    },
    generateModuleObject(module, separateLinks = false) {
      let modules = [];
      if (module.links.length > 0) {
        if (separateLinks) {
          for (let i = 0; i < module.links.length; i++) {
            modules.push({
              title: module.links[i].text,
              link: module.links[i].href,
              iconText: module.links[i].icon,
              useRouter: false,
              active: false,
            });
          }
        } else {
          modules.push({
            title: module.title,
            iconText: module.icon,
            subModules: module.links,
            useRouter: false,
            active: false,
          });
          for (let j = 0; j < module.links.length; j++) {
            if (module.links[j].subLinks) {
              modules[0].subModules.push({
                href: module.links[j].subLinks[0].href,
                text: module.links[j].subLinks[0].text,
                iconText: 'trending_flat',
              });
            }
          }
        }
        return modules;
      }
    },
    getUserModules() {
      let userModules = [],
        moduleObjects = [];
      moduleObjects = this.generateModuleObject(this.myDashboard, true);
      userModules = userModules.concat(moduleObjects);
      moduleObjects = this.generateModuleObject(this.ownershipManagement);
      if (moduleObjects) userModules = userModules.concat(moduleObjects);
      moduleObjects = this.generateModuleObject(this.accounts);
      if (moduleObjects) userModules = userModules.concat(moduleObjects);
      moduleObjects = this.generateModuleObject(this.groups);
      if (moduleObjects) userModules = userModules.concat(moduleObjects);
      moduleObjects = this.generateModuleObject(this.data);
      if (moduleObjects) userModules = userModules.concat(moduleObjects);
      moduleObjects = this.generateModuleObject(this.hygieneCenter);
      if (moduleObjects) {
        // make sure to only show the workers when ARM is enabled
        if (moduleObjects[0].subModules.length > 1) {
          userModules = userModules.concat(moduleObjects[0]);
        }
      }
      moduleObjects = this.generateModuleObject(this.admin, true);
      if (moduleObjects) userModules = userModules.concat(moduleObjects);
      return userModules;
    },
    addListenerForNavDrawerClicks() {
      //FIXME: this `clickout` directive is probably exactly what we want to close
      // the sidebar when someone clicks outside of it
      //https://github.com/Stegosource/vuetensils/blob/master/src/directives/clickout.js
      document.addEventListener(
        'mousedown',
        (e) => {
          if (this.open === true) {
            let blockInputEvent = false;
            if (
              this.elementIsPartOfSidebarControls(e.target) ||
              this.elementIsBurgerMenu(e.target)
            ) {
              blockInputEvent = true;
            }
            if (e.target.children !== undefined) {
              for (let i = 0; i < e.target.children.length; i++) {
                const elem = e.target.children[i];
                if (this.elementIsPartOfSidebarControls(elem)) {
                  blockInputEvent = true;
                }
              }
            }
            this.emitInputEvent(blockInputEvent);
          }
        },
        true
      );
    },
    emitInputEvent(blockInputEvent) {
      if (!blockInputEvent) {
        this.$emit('input', this.open);
      }
    },
    elementIsPartOfSidebarControls(elem) {
      if (!elem) return false;
      if (elem.classList.contains('sb-nav-drawer')) return true;
      if (elem.classList.contains('glyphicon-menu-hamburger')) return true;
      if (this.checkElementIsPartOfSidebarControls(elem)) {
        return true;
      }
      return false;
    },
    checkElementIsPartOfSidebarControls(elem) {
      return (
        elem.classList.contains('v-icon') && elem.innerText.includes('menu')
      );
    },
    elementIsBurgerMenu(elem) {
      if (!elem) return false;
      if (elem.classList.contains('main-hamburger-menu')) return true;
      return false;
    },
    highlightActiveLink(item) {
      if (!item.useRouter) {
        let highLight = false;
        let link = item.link || item.href;
        if (link) {
          let url = link.toLowerCase();
          url = url.split('#')[0];
          if (
            this.currentLink == url ||
            this.checkHighlightActiveLink(item, url)
          ) {
            highLight = true;
          }
        } else {
          if (this.checkHighlightActiveLink(item, undefined)) {
            highLight = true;
          }
        }
        return highLight;
      }
    },
    checkHighlightActiveLink(item, url) {
      return (
        (url &&
          this.currentLink.includes(url) &&
          item.title != 'Hygiene Hub' &&
          !this.currentLink.includes('/beta')) ||
        (item.subModules &&
          item.subModules.some((ele) =>
            this.currentLink.includes(ele.href.split('#')[0].toLowerCase())
          ))
      );
    },
  },
};
</script>
<style lang="scss">
.sb-left-menu {
  .v-list__tile:not(a) {
    height: unset !important;
    min-height: 40px;
    &.v-list__tile--active {
      .v-list__group__header__append-icon .v-icon {
        color: #fff;
      }
      &:after {
        background-color: unset;
      }
      .v-list__group__header:after {
        background-color: #00538d;
      }
    }
    .v-list__group__items {
      .v-list__tile {
        &:not(.v-list__tile--active) {
          .v-list__tile__title {
            color: #52575f;
          }
        }
        &.v-list__tile--active {
          .v-list__tile__title .v-icon {
            color: #fff;
          }
        }
      }
    }
    .v-list__group {
      width: 100%;
      &.v-list__group--active {
        .v-list__group__header:after {
          border-color: #00538d;
        }
      }
      .v-list__group__header {
        min-height: 40px;
        position: relative;
        &:after {
          content: '';
          width: calc(100% - 16px);
          height: 80%;
          border: 2px solid transparent;
          border-radius: 2px;
          position: absolute;
          left: 10px;
          opacity: 1;
        }
        &:hover {
          background: none;
          &:after {
            border-color: #00538d;
          }
        }
        .v-list__group__header__append-icon {
          padding-right: 10px;
        }
      }
      .v-list__group__items {
        padding-left: 60px;
        .v-list__tile:after {
          left: -6px;
          width: 100%;
        }
      }
    }
  }
}
</style>
